(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9549],{

/***/ 63391:
/***/ (function(module) {

function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = 63391;
module.exports = webpackEmptyContext;

/***/ }),

/***/ 9359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/india/returns",
      function () {
        return __webpack_require__(80682);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-arrow.e6d9293c.svg","height":19,"width":25});

/***/ }),

/***/ 28139:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/info.7d3d3a1b.svg","height":17,"width":16});

/***/ }),

/***/ 99491:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/install-service-cart-icon.d2fc242a.svg","height":62,"width":62});

/***/ }),

/***/ 59066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/tooltip-questionmark.1d97c4ec.svg","height":24,"width":16});

/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7154);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55111);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34326);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={} , analyticsEvent , analyticsData  } = props;
    const isHomePage = (url)=>{
        return !url || url === _constants_index__WEBPACK_IMPORTED_MODULE_5__.HOMEPAGEURL ? "/" : url;
    };
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const ITEM_TYPE = {
        breadcrumbList: "http://schema.org/BreadcrumbList",
        listItem: "http://schema.org/ListItem"
    };
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>(0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url));
        setShortURLs(urls);
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).map((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants_index__WEBPACK_IMPORTED_MODULE_5__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        let path = "";
        for(let i = 0; i < index; i++){
            var ref;
            path += "".concat((ref = items[i].title) === null || ref === void 0 ? void 0 : ref.toLowerCase(), " > ");
        }
        if (!isSsr) {
            var ref1;
            let eventInfo = {
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: path + (navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()),
                internalLinkPosition: eventPageName,
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: (navItem === null || navItem === void 0 ? void 0 : navItem.url) ? (navItem.url.indexOf("http") === -1 ? window.location.origin : "") + (0,_utils_helper__WEBPACK_IMPORTED_MODULE_6__.removeAndCleanLinkConcat)(navItem.url) : "n/a",
                internalLinkZoneName: eventPageName + ":" + zone
            };
            if (analyticsData) {
                eventInfo = {
                    ...eventInfo,
                    ...analyticsData
                };
            }
            return JSON.stringify(eventInfo);
        }
    };
    const handleClick = (navItem)=>{
        if (analyticsEvent) {
            analyticsEvent(navItem);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "breadcrumb ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
        children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            id: "breadcrumb",
            className: "cmp-breadcrumb",
            "aria-label": "Breadcrumb",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                className: "cmp-breadcrumb__list",
                itemScope: true,
                itemType: ITEM_TYPE.breadcrumbList,
                children: items.map((navItem, index)=>{
                    const isLastItem = index === items.length - 1;
                    const isActive = navItem.active;
                    const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "cmp-breadcrumb__item",
                        itemProp: "itemListElement",
                        itemScope: true,
                        itemType: ITEM_TYPE.listItem,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: isHomePage(shortURLs[index]),
                                className: "cmp-breadcrumb__item-link",
                                itemProp: "item",
                                "data-zone": zone,
                                "aria-label": navItem.title,
                                "aria-current": navItem.active ? "page" : null,
                                "data-gbh-data-layer": !analyticsEvent && !isSsr ? getEventInfo(navItem, index) : null,
                                onClick: ()=>handleClick(navItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    itemProp: "name",
                                    dangerouslySetInnerHTML: {
                                        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                    }
                                })
                            }),
                            shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "cmp-breadcrumb-slash",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                itemProp: "position",
                                content: index + 1
                            })
                        ]
                    }, "breadcrumb-item-".concat(index));
                })
            })
        }) : null
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumb);


/***/ }),

/***/ 15661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JC": function() { return /* binding */ getLocations; },
/* harmony export */   "KL": function() { return /* binding */ getProductDetails; },
/* harmony export */   "Pu": function() { return /* binding */ editButtonAnalyticsEventInfoStep; },
/* harmony export */   "R9": function() { return /* binding */ getReviewRegistrationEventInfo; },
/* harmony export */   "SE": function() { return /* binding */ productInfoHandleSubmit; },
/* harmony export */   "VS": function() { return /* binding */ addReviewRegistrationAnalytics; },
/* harmony export */   "YU": function() { return /* binding */ submitRegistrationGenericError; },
/* harmony export */   "e7": function() { return /* binding */ addRegistrationInformationAnalytics; },
/* harmony export */   "fv": function() { return /* binding */ getProductConfirmationEventInfo; },
/* harmony export */   "fz": function() { return /* binding */ editButtonAnalyticsEventInfo; },
/* harmony export */   "mh": function() { return /* binding */ getAddAnotherProductAnalytics; },
/* harmony export */   "oP": function() { return /* binding */ getOfflineReviewProductsAnalytics; },
/* harmony export */   "q$": function() { return /* binding */ modalNumberSupportLinkEventInfo; },
/* harmony export */   "qf": function() { return /* binding */ getRemoveOfflineProductsAnalytics; },
/* harmony export */   "sg": function() { return /* binding */ addProductInformationAnalytics; },
/* harmony export */   "xX": function() { return /* binding */ getBackToProductsAnalytics; }
/* harmony export */ });
/* unused harmony export addReviewRegistrationEventInfo */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34326);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45094);




// Analytics *********************
const editButtonAnalyticsEventInfo = (type)=>{
    return JSON.stringify({
        eventAction: "my account:register offline kohler products:".concat(type, ":edit"),
        eventName: "my account:register offline kohler products:".concat(type, ":edit"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:".concat(type),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
};
const editButtonAnalyticsEventInfoStep = (type)=>{
    const eventInfo = {
        eventAction: "my account:register offline kohler products:".concat(type, ":edit"),
        eventName: "my account:register offline kohler products:".concat(type, ":edit"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:".concat(type),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo
    });
};
const getBackToProductsAnalytics = (isSuccess, myProductsPath)=>{
    const pageName = isSuccess ? "thank you for registering the products" : "top navigation";
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:".concat(pageName, ":back to my products"),
        eventName: "my account:register offline kohler products:".concat(pageName, ":back to my products"),
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to my products",
        eventType: "navigation",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkURL: ((myProductsPath === null || myProductsPath === void 0 ? void 0 : myProductsPath.indexOf("http")) === -1 ? window.location.origin : "") + myProductsPath,
        internalLinkZoneName: "my account:register offline kohler products:".concat(pageName)
    });
};
const getProductConfirmationEventInfo = (linkUrl, productData)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:product registration summary:back to homepage",
        eventName: "my account:register offline kohler products:product registration summary:back to homepage",
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "back to homepage",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkURL: (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl,
        internalLinkZoneName: "my account:register offline kohler products:product registration summary"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productDetails: data.productDetails.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            dealerName: data.dealerName.value || "n/a",
            dateOfPurchase: data.dateOfPurchase.value || "n/a",
            customerImage: data.customerImage || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
const getOfflineReviewProductsAnalytics = (myProductsPath, productData)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:thank you for sharing the details:back to homepage",
        eventMsg: "n/a",
        eventName: "my account:register offline kohler products:thank you for sharing the details:back to homepage",
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "back to homepage",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkURL: ((myProductsPath === null || myProductsPath === void 0 ? void 0 : myProductsPath.indexOf("http")) === -1 ? window.location.origin : "") + myProductsPath,
        internalLinkZoneName: "my account:register offline kohler products:thank you for sharing the details"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productDetails: data.productDetails.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            dealerName: data.dealerName.value || "n/a",
            dateOfPurchase: data.dateOfPurchase.value || "n/a",
            customerImage: data.customerImage || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        page,
        eventInfo,
        productInfo: ProductInfo
    });
};
// step product information **********
const addProductInformationAnalytics = (action, productData, status, errorsList)=>{
    if (status && status !== "success") {
        var ref;
        errorsList = ((ref = errorsList.join(":")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "n/a";
    }
    const eventInfo = {
        eventAction: "my account:register offline kohler products:product information:next step",
        eventName: "my account:register offline kohler products:product information:next step",
        eventType: "navigation",
        eventMsg: errorsList || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:product information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productDetails: data.productDetails.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            dealerName: data.dealerName.value || "n/a",
            dateOfPurchase: data.dateOfPurchase.value || "n/a",
            customerImage: data.customerImage || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
// delete window.pageObj
};
// product form
const getRemoveOfflineProductsAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:product information:remove",
        eventName: "my account:register offline kohler products:product information:remove",
        eventType: "informative",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:product information",
        internalLinkURL: "n/a"
    });
};
const modalNumberSupportLinkEventInfo = JSON.stringify({
    eventAction: "my account:register offline kohler products:product information:how to find your model number",
    eventName: "my account:register offline kohler products:product information:how to find your model number",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "how to find your model number",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: "my account:register offline kohler products:product information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const getAddAnotherProductAnalytics = ()=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "my account:register offline kohler products:product information:add another product to register",
        eventName: "my account:register offline kohler products:product information:add another product to register",
        eventType: "informative",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "add another product to register",
        internalLinkPosition: "register offline kohler products",
        internalLinkType: "my account:navigation",
        internalLinkURL: "n/a",
        internalLinkZoneName: "my account:register offline kohler products:product information"
    });
};
// step registrationInformation***
const addRegistrationInformationAnalytics = (productDetails, action, status, errorsList)=>{
    if (status && status !== "success") {
        var ref;
        errorsList = ((ref = errorsList.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "n/a";
    }
    const eventInfo = {
        eventAction: "my account:register offline kohler products:personal information:next step",
        eventName: "my account:register offline kohler products:personal information:next step",
        eventType: "navigation",
        eventMsg: errorsList || "n/a",
        eventStatus: status,
        internalLinkName: "next step",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:personal information",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productDetails === null || productDetails === void 0 ? void 0 : productDetails.map((data)=>{
        const obj = {
            productDetails: data.productDetails.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            dealerName: data.dealerName.value || "n/a",
            dateOfPurchase: data.dateOfPurchase.value || "n/a",
            customerImage: data.customerImage || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
// delete window.pageObj
};
// step reviewInformation
const getReviewRegistrationEventInfo = (type, linkUrl)=>{
    return JSON.stringify(addReviewRegistrationEventInfo(type, linkUrl));
};
const addReviewRegistrationEventInfo = function(type, linkUrl) {
    let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
    const linkFor = type === null || type === void 0 ? void 0 : type.toLowerCase();
    return {
        eventAction: "my account:register offline kohler products:review and register:".concat(linkFor),
        eventName: "my account:register offline kohler products:review and register:".concat(linkFor),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkFor,
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:review and register",
        internalLinkURL: linkUrl,
        clickInternalLinks
    };
};
const addReviewRegistrationAnalytics = (action, status, productData, message)=>{
    const eventInfo = {
        eventAction: "my account:register offline kohler products:review and register:submit registration",
        eventName: "my account:register offline kohler products:review and register:submit registration",
        eventType: "navigation",
        eventMsg: message || "n/a",
        eventStatus: status || "n/a",
        internalLinkName: "submit registration",
        internalLinkPosition: "register products",
        internalLinkType: "my account:navigation",
        internalLinkZoneName: "my account:register offline kohler products:review and register",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const ProductInfo = [];
    productData === null || productData === void 0 ? void 0 : productData.map((data)=>{
        const obj = {
            productDetails: data.productDetails.value || "n/a",
            serialNumber: data.serialNumber.value || "n/a",
            dealerName: data.dealerName.value || "n/a",
            dateOfPurchase: data.dateOfPurchase.value || "n/a",
            customerImage: data.customerImage || "n/a",
            uploadedImage: data.uploadedImage || "n/a"
        };
        ProductInfo.push(obj);
    });
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = action === "cmp:show" ? window.pageObj : getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: action,
        page,
        eventInfo,
        productInfo: ProductInfo
    });
// delete window.pageObj
};
// END--Analytics *********************
// step product information **********
const productInfoHandleSubmit = (data, staticText)=>{
    let valid = true;
    const newData = [];
    const errorMessage = [];
    data.map((formItem)=>{
        const obj = {};
        if (!formItem.productDetails.value) {
            obj.productDetails = {
                ...formItem.productDetails,
                error: true,
                message: props.i18n.productError
            };
            valid = false;
            errorMessage.push(props.i18n.productError);
        }
        if (!formItem.dateOfPurchase.value) {
            obj.dateOfPurchase = {
                ...formItem.dateOfPurchase,
                error: true,
                message: props.i18n.placeOfPurchaseError
            };
            valid = false;
            errorMessage.push(staticText.placeOfPurchaseError);
        }
        newData.push({
            ...formItem,
            ...obj
        });
    });
    return {
        newData: newData,
        valid: valid,
        errorMessage: errorMessage
    };
};
const getLocations = async ()=>{
    await _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .getGenericListPath */ .Ln)());
    const { payload: countryList  } = await _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .getCountryList */ .Jp)());
    const { payload: stateList  } = await _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .getstateList */ .lK)());
    await _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .getplaceOfPurchaseList */ .GL)());
    if (countryList.length) _store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_1__/* .mapStateToCountry */ .UD)({
        countryList,
        stateList
    }));
};
// register-offline-products
const getProductDetails = function() {
    let productDetail = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const productDetails = [];
    if (productDetail && productDetail.length > 0) {
        productDetail.forEach((item)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            const productList = {};
            productList.productDetail = (ref = item.productDetails) === null || ref === void 0 ? void 0 : ref.value;
            productList.serialNumber = ((ref1 = item.serialNumber) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.trim().length) > 0 ? (ref3 = item.serialNumber) === null || ref3 === void 0 ? void 0 : ref3.value : "N/A";
            productList.dealerName = ((ref4 = item.dealerName) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.trim().length) > 0 ? (ref6 = item.dealerName) === null || ref6 === void 0 ? void 0 : ref6.value : "N/A";
            productList.dateOfPurchase = (ref8 = moment__WEBPACK_IMPORTED_MODULE_0___default()((ref7 = item.dateOfPurchase) === null || ref7 === void 0 ? void 0 : ref7.value)) === null || ref8 === void 0 ? void 0 : ref8.format("DD/MM/YYYY");
            productList.invoiceData = item.productImages;
            productDetails.push(productList);
        });
    }
    return productDetails;
};
const submitRegistrationGenericError = (productDetails, errorMsg)=>{
    const isShowEvent = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_2__.isShowAnalyticsEventLoaded)();
    if (!isShowEvent) {
        addReviewRegistrationAnalytics("cmp:click", "failure", productDetails, errorMsg);
    }
};



/***/ }),

/***/ 29754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StepNavigator_StepNavigator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/core/StepNavigator/StepNav.module.scss
var StepNav_module = __webpack_require__(78112);
var StepNav_module_default = /*#__PURE__*/__webpack_require__.n(StepNav_module);
;// CONCATENATED MODULE: ./src/components/checkout/ShippingFiller.jsx


const ShippingFiller = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "shipping-address",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "shipping-address__form",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "shipping-address__checkout-fast",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "shimmer-loading__para30 shimmer width-250"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shipping-address__checkout-fast-cta",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "shimmer-loading__para30 shimmer width-170"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "shipping-form container px-0 mx-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "shipping-form__required-fields",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__input shimmer"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__input shimmer"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 shipping-form__pl10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-9 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-3 shipping-form__pl10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-3 mb-20 shipping-form__pl10 shipping-form__pr10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-3 shipping-form__pl10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__input shimmer"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__input shimmer"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var checkout_ShippingFiller = (ShippingFiller);

// EXTERNAL MODULE: ./store/features/checkoutSlice.js
var checkoutSlice = __webpack_require__(60475);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/checkout/v1/checkoutAnalytics.js
var checkoutAnalytics = __webpack_require__(82883);
// EXTERNAL MODULE: ./components/RegisterOfflineProduct/v1/RegisterOfflineHelper.js
var RegisterOfflineHelper = __webpack_require__(15661);
;// CONCATENATED MODULE: ./components/core/StepNavigator/StepNavigator.jsx












const StepNavigator = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { data , placeOrder , handleSuccess , handlePaymentStep =()=>{} , checkoutMode ="" , addrSet =false , changeCurStep =()=>{}  } = param;
    const [curStep, setCurStep] = (0,react.useState)(checkoutMode === "one-step" && addrSet === "true" ? 1 : 0);
    const statusCode = {
        PENDING: "pending",
        COMPLETE: "complete",
        EDIT: "edit"
    };
    const [status, setStatus] = (0,react.useState)(data === null || data === void 0 ? void 0 : data.map((d, i)=>{
        if (i === 0 && checkoutMode === "one-step" && addrSet === "true") {
            return statusCode.COMPLETE;
        }
        return statusCode.PENDING;
    }));
    const [open, setOpen] = (0,react.useState)(data === null || data === void 0 ? void 0 : data.map(()=>false));
    const stepNavRef = (0,react.useRef)([]);
    const dispatch = (0,es/* useDispatch */.I0)();
    const handleNext = ()=>{
        updateStatus(curStep, statusCode.COMPLETE);
        if (curStep < (data === null || data === void 0 ? void 0 : data.length) - 1) {
            setCurStep(curStep + 1);
        }
    };
    (0,react.useImperativeHandle)(ref, ()=>({
            handleNext
        }));
    const handleEdit = (step)=>{
        window.pageLoad = false;
        if (step === 0) {
            var ref;
            if (((ref = data[0]) === null || ref === void 0 ? void 0 : ref.label) === "Personal Information") {
                (0,RegisterOfflineHelper/* editButtonAnalyticsEventInfoStep */.Pu)("personal information");
            } else {
                (0,checkoutAnalytics/* editCartAnalytics */.ak)();
            }
        }
        if (step === 1) {
            var ref1;
            if (((ref1 = data[1]) === null || ref1 === void 0 ? void 0 : ref1.label) === "Product Information") {
                (0,RegisterOfflineHelper/* editButtonAnalyticsEventInfoStep */.Pu)("product information");
            } else {
                (0,checkoutAnalytics/* editDeliveryAnalytics */.Hi)();
            }
        }
        setCurStep(step);
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("set-step", changeStep);
        window.pageLoad = true;
        return ()=>{
            document.removeEventListener("set-step", changeStep);
        };
    }, []);
    const changeStep = (e)=>{
        if (curStep !== 0) {
            var ref;
            var ref1;
            setCurStep((ref1 = e === null || e === void 0 ? void 0 : (ref = e.detail) === null || ref === void 0 ? void 0 : ref.count) !== null && ref1 !== void 0 ? ref1 : 0);
        }
    };
    (0,react.useEffect)(()=>{
        if (curStep !== 3) {
            dispatch((0,checkoutSlice/* setIsPaymentInfoAction */.hK)(false));
        }
        changeCurStep(curStep);
        handlePaymentStep(curStep);
        dispatch((0,checkoutSlice/* setCheckoutAction */.BZ)(curStep));
    }, [
        curStep
    ]);
    const handleOpen = (step, label)=>{
        const newOpen = [
            ...open
        ];
        newOpen[step] = !open[step];
        setOpen(newOpen);
        addAnalyticsData(step, newOpen, label);
    };
    const addAnalyticsData = (step, newOpen, label)=>{
        var ref, ref1, ref2, ref3;
        const collapseExpand = newOpen[step] ? "expand" : "collapse";
        const type = label === null || label === void 0 ? void 0 : label.toLowerCase();
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const onlineOrOffline = ((ref = window.adobeDataLayer[1]) === null || ref === void 0 ? void 0 : (ref1 = ref.page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.category) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subCategoryID) === null || ref3 === void 0 ? void 0 : ref3.includes("offline")) ? "offline" : "online";
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "my account:register ".concat(onlineOrOffline, " kohler products:").concat(type, ":accordion ").concat(collapseExpand),
            eventName: "my account:register ".concat(onlineOrOffline, " kohler products:").concat(type, ":accordion ").concat(collapseExpand),
            eventMsg: "n/a",
            eventStatus: "n/a",
            eventType: "navigation",
            internalLinkName: collapseExpand,
            internalLinkPosition: "register products",
            internalLinkType: "my account:navigation",
            internalLinkURL: "n/a",
            internalLinkZoneName: "my account:register ".concat(onlineOrOffline, " kohler products:").concat(type)
        };
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const updateStatus = (step, code)=>{
        const newStatus = [
            ...status
        ];
        newStatus[step] = code;
        if (code === statusCode.EDIT) {
            if (step !== 0 && !(window === null || window === void 0 ? void 0 : window.pageLoad)) {
                var ref;
                (ref = stepNavRef.current[step]) === null || ref === void 0 ? void 0 : ref.scrollIntoView(true);
            }
            for(let i = step + 1; i < (data === null || data === void 0 ? void 0 : data.length); i++){
                newStatus[i] = statusCode.PENDING;
            }
        }
        setStatus(newStatus);
    };
    (0,react.useEffect)(()=>updateStatus(curStep, statusCode.EDIT), [
        curStep
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (StepNav_module_default()).stepNavWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "step-nav",
            children: data === null || data === void 0 ? void 0 : data.map((param, i)=>/*#__PURE__*/ {
                let { label , editButtonAnalytics , content: Component , props , ref =null  } = param;
                return (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()({
                        "step-nav__step": true,
                        "step-nav__step--active": i === curStep,
                        "step-nav__step--done": status[i] === statusCode.COMPLETE
                    }),
                    id: "step-nav-step-".concat(i),
                    tabIndex: "-1",
                    ref: (element)=>stepNavRef.current.push(element),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "step-nav__number d-none d-lg-block",
                            children: i + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "step-nav__content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "step-nav__title",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "step-nav__title-container",
                                            "aria-current": i === curStep ? "step" : "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "step-nav__number--mobile",
                                                        children: [
                                                            i + 1,
                                                            " "
                                                        ]
                                                    }),
                                                    label
                                                ]
                                            })
                                        }),
                                        curStep > i && !props.hideEdit && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            ariaLabel: "Edit ".concat(label),
                                            customClass: "step-nav__edit-btn",
                                            className: editButtonAnalytics ? "gbh-data-layer" : "",
                                            size: "small",
                                            type: "ghost",
                                            label: "Edit",
                                            onClick: ()=>handleEdit(i)
                                        }),
                                        status[i] === statusCode.COMPLETE && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": "Edit ".concat(label),
                                            "aria-expanded": open[i],
                                            className: "step-nav__plus ".concat(open[i] ? "--open" : ""),
                                            onClick: ()=>handleOpen(i, label),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line line-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "line line-2"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                label === "Shipping" && status[i] === statusCode.PENDING && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    role: "group",
                                    className: "step-nav__component--open",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_ShippingFiller, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    role: "group",
                                    className: "step-nav__component ".concat(status[i] === statusCode.EDIT || status[i] === statusCode.COMPLETE && open[i] ? "--open" : "", " ").concat(status[i] === statusCode.EDIT || status[i] === statusCode.COMPLETE && open[i] ? "order-summary-mobile-block" : ""),
                                    children: [
                                        status[i] !== statusCode.PENDING && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                                            status: status[i],
                                            statusCode: statusCode,
                                            ...props,
                                            onNext: handleNext,
                                            placeOrder: placeOrder,
                                            handleSuccess: handleSuccess,
                                            curStep: curStep,
                                            ref: ref
                                        }),
                                        curStep > i && lib/* isMobile */.tq && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            tabIndex: open[i] ? 0 : 1,
                                            ariaLabel: "Edit ".concat(label),
                                            className: editButtonAnalytics ? "gbh-data-layer" : "",
                                            "data-gbh-data-layer": editButtonAnalytics || null,
                                            customClass: "step-nav__edit-btn--mobile",
                                            size: "small",
                                            type: "ghost",
                                            label: "Edit",
                                            onClick: ()=>handleEdit(i),
                                            useDefaultClass: true
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, i);
            })
        })
    });
});
/* harmony default export */ var StepNavigator_StepNavigator = (StepNavigator);
StepNavigator.propTypes = {
    data: (prop_types_default()).array.isRequired
};


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34326);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33273);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7154);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55111);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_downloadFile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58589);












const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    // useEffect(() => {
    //   let timeoutId
    //   if (!isSsr) {
    //     timeoutId = setTimeout(() => {
    //       if (!accessToken || !isGuestTokenValid()) {
    //         dispatch(getOktaToken("guest"))
    //       }
    //     }, 5000)
    //   }
    //   ;() => {
    //     clearTimeout(timeoutId)
    //   }
    // }, [accessToken, isSsr])
    // useEffect(() => {
    //   const userLoggedIn = localStorage.getItem("userLoggedIn")
    //   if (userLoggedIn === "false" || userLoggedIn === null) {
    //     if (!isGuestTokenValid()) {
    //       dispatch(getAnonymousGuestToken())
    //     }
    //   }
    // }, [])
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.isGuestTokenValid)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                    (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__.getCurrency)().then((currency)=>{
                        const cartPayload = {
                            currency: currency
                        };
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                        });
                    });
                }
            });
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 80682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ returns; },
  "getServerSideProps": function() { return /* binding */ getServerSideProps; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
// EXTERNAL MODULE: ./node_modules/next-i18next/serverSideTranslations.js
var serverSideTranslations = __webpack_require__(55709);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 93 modules
var AemGrid = __webpack_require__(55064);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx + 1 modules
var GlobalPageFooter = __webpack_require__(74859);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./store/index.js + 1 modules
var store = __webpack_require__(45094);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./components/Returns/v1/ReturnSummary/returnSummary.module.scss
var returnSummary_module = __webpack_require__(64851);
var returnSummary_module_default = /*#__PURE__*/__webpack_require__.n(returnSummary_module);
// EXTERNAL MODULE: ./node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(36609);
;// CONCATENATED MODULE: ./components/Returns/v1/localization.js

const getTranslations = (t)=>{
    return {
        returnRequestOrder: (orderID, count, total)=>t("kf.returns.label.returnRequestOrder", {
                orderID,
                count,
                total
            }),
        returnDescription: t("kf.returns.label.returnDescription"),
        itemDescription: t("kf.returns.label.itemDescription"),
        returnNext: t("kf.returns.label.returnNext"),
        returnReviewSubmit: t("kf.returns.label.returnReviewSubmit"),
        returnTrack: t("kf.returns.label.returnTrack"),
        returnRequest: t("kf.returns.label.returnRequest"),
        returnProvideFeedback: t("kf.returns.label.returnProvideFeedback"),
        faultDescription: t("kf.returns.label.faultDescription"),
        faultLink: t("kf.returns.label.faultLink"),
        contactRequired: t("kf.returns.label.contactRequired"),
        reviewDescription: t("kf.returns.label.reviewDescription"),
        reviewPara: t("kf.returns.label.reviewPara"),
        reviewTerms: t("kf.returns.label.reviewTerms"),
        reviewParagraph: t("kf.returns.label.reviewParagraph"),
        reviewPrivacy: t("kf.returns.label.reviewPrivacy"),
        summaryTitle: t("kf.returns.label.summaryTitle"),
        "kf.returns.label.summaryTitle": "RETURN SUMMARY",
        summarySubTotal: t("kf.returns.label.summarySubTotal"),
        summaryTotal: t("kf.returns.label.summaryTotal"),
        summaryShipping: t("kf.returns.label.summaryShipping"),
        summaryFree: t("kf.returns.label.summaryFree"),
        returnRefund: t("kf.returns.label.returnRefund"),
        totalDiscount: t("kf.returns.label.totalDiscount"),
        refundTotal: t("kf.returns.label.refundTotal"),
        summaryRefundCost: t("kf.returns.label.summaryRefundCost"),
        summaryTax: t("kf.returns.label.summaryTax"),
        including: t("kf.returns.label.including"),
        taxes: t("kf.returns.label.taxes"),
        summaryChat: t("kf.returns.label.summaryChat"),
        summaryAgent: t("kf.returns.label.summaryAgent"),
        summaryCall: t("kf.returns.label.summaryCall"),
        summaryTel: t("kf.returns.label.summaryTel"),
        returnBack: t("kf.returns.label.returnBack"),
        requestTitle: t("kf.returns.label.requestTitle"),
        requestID: t("kf.returns.label.requestID"),
        requestTID: t("kf.returns.label.requestTID"),
        requestStatus: t("kf.returns.label.requestStatus"),
        requestTransit: t("kf.returns.label.requestTransit"),
        requestTracking: t("kf.returns.label.requestTracking"),
        requestTrackID: t("kf.returns.label.requestTrackID"),
        requestTrackLink: t("kf.returns.label.requestTrackLink"),
        requestFed: t("kf.returns.label.requestFed"),
        requestFaulty: t("kf.returns.label.requestFaulty"),
        requestProdDetails: t("kf.returns.label.requestProdDetails"),
        requestSerialNo: t("kf.returns.label.requestSerialNo"),
        requestDealerName: t("kf.returns.label.requestDealerName"),
        requestProdDate: t("kf.returns.label.requestProdDate"),
        requestContact: t("kf.returns.label.requestContact"),
        requestContactName: t("kf.returns.label.requestContactName"),
        returnConfirmTitle: t("kf.returns.label.returnConfirmTitle"),
        returnConfirmPara: t("kf.returns.label.returnConfirmPara"),
        returnConfirmDay: t("kf.returns.label.returnConfirmDay"),
        returnConfirmItem: t("kf.returns.label.returnConfirmItem"),
        returnHelp: t("kf.returns.label.returnHelp"),
        returnerItems: t("kf.returns.label.returnerItems"),
        returnedItems: t("kf.returns.label.returnedItems"),
        returnerQuantity: t("kf.returns.label.returnerQuantity"),
        colorFinish: t("kf.returns.label.colorFinish"),
        returnQuantityValue: t("kf.returns.label.returnQuantityValue"),
        returnReason: t("kf.returns.label.returnReason"),
        returnReasonVal: t("kf.returns.label.returnReasonVal"),
        reasonForReturn: t("kf.returns.label.reasonsForReturn"),
        reasonError: t("kf.returns.label.reasonReturnError"),
        commentBoxPlaceholder: t("kf.returns.label.commentBoxPlaceholder"),
        dragAndDrop: t("kf.returns.label.dragAndDrop"),
        orText: t("kf.returns.label.orText"),
        uploadFileButton: t("kf.returns.label.uploadFileButton"),
        backToOrder: t("kf.returns.label.backToOrder"),
        installationService: (sku)=>t("kf.returns.label.installationService", {
                sku
            }),
        returnItem: t("kf.returns.label.returnItem"),
        faulty: t("kf.returns.label.faulty"),
        contactInfo: t("kf.returns.label.contactInfo"),
        review: t("kf.returns.label.review"),
        areYou: t("kf.returns.label.areYou"),
        allProgress: t("kf.returns.label.allProgress"),
        yes: t("kf.returns.label.yes"),
        no: t("kf.returns.label.no"),
        related: t("kf.returns.label.returnRelated"),
        eligible: t("kf.returns.label.returnEligible"),
        following: t("kf.returns.label.returnFollowing"),
        service: t("kf.returns.label.returnService"),
        imageUpload: t("kf.returns.label.imageUpload"),
        refundAmount: t("kf.returns.label.refundAmount"),
        noReason: t("kf.returns.label.noReason"),
        uploadPhoto: t("kf.returns.label.uploadFileButton"),
        uploadCountLimit: t("kf.returns.label.uploadCountLimit"),
        uploadMBLimit: t("kf.contactus.error.maxFileSizeLimit"),
        orText: t("kf.returns.label.orText"),
        errorFileType: t("kf.returns.label.fileType"),
        description: t("kf.returns.image.description"),
        shippingTooltip: t("kf.cart.label.shippingTooltip")
    };
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./src/components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(45138);
// EXTERNAL MODULE: ./public/icons/tooltip-questionmark.svg
var tooltip_questionmark = __webpack_require__(59066);
;// CONCATENATED MODULE: ./components/Returns/v1/ReturnSummary/ReturnSummary.jsx








const ReturnSummary = (param)=>{
    let { data ={} , currencySign ="" , returnedItems ={} , quantityVal =""  } = param;
    const [tooltipFlag, setTooltipFlag] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { price ="" , discAmount ="" , taxPercentage =""  } = data;
    const handleDiscount = (discount, quantityVal, selectedQuantity)=>{
        const getDiscount = discount / quantityVal * selectedQuantity;
        return getDiscount;
    };
    const handleTax = (tax, priceVal)=>{
        var ref;
        const getTaxPercentage = parseFloat(tax) + 100;
        const getTax = (ref = Number(tax / getTaxPercentage * priceVal)) === null || ref === void 0 ? void 0 : ref.toFixed(2);
        return getTax !== null && getTax !== void 0 ? getTax : 0;
    };
    const handleMRP = (price, quantity)=>{
        const getMRP = price * quantity;
        return getMRP;
    };
    const handleTooltip = ()=>{
        setTooltipFlag(!tooltipFlag);
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (returnSummary_module_default()).returnSummary,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: staticText.summaryTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "summary-detail summary-detail-total",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            " ",
                            staticText.summarySubTotal
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: (ref = handleMRP(price, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity)) !== null && ref !== void 0 ? ref : 0,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            thousandsGroupStyle: "lakh"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "summary-detail summary-detail-total-discount",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: staticText.totalDiscount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: handleDiscount(discAmount, quantityVal, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity),
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            thousandsGroupStyle: "lakh",
                            allowNegative: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "summary-detail summary-detail-shipping",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            staticText.summaryShipping,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: tooltip_questionmark/* default.src */.Z.src,
                                margin: "unset",
                                alt: "tooltip",
                                className: "order-summary__tooltip-icon",
                                onMouseOver: ()=>{
                                    setTooltipFlag(true);
                                },
                                onMouseOut: ()=>setTooltipFlag(false),
                                onClick: handleTooltip
                            })
                        ]
                    }),
                    staticText.shippingTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "order-summary__tooltip--".concat(tooltipFlag ? "show" : "hide"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-summary__tooltip-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                message: staticText.shippingTooltip
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: staticText.summaryFree
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "summary-detail summary-detail-refund",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: staticText.refundTotal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: handleMRP(price, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity) - handleDiscount(discAmount, quantityVal, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity),
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currencySign,
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            thousandsGroupStyle: "lakh"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "summary-detail summary-detail-tax",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            " ",
                            staticText.summaryTax
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "summary-tax-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: staticText.including
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: handleTax(taxPercentage, handleMRP(price, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity) - handleDiscount(discAmount, quantityVal, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity)),
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    thousandsGroupStyle: "lakh"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: staticText.taxes
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "call-support",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "call-support-call",
                        children: staticText.summaryCall
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "tel:1-800-103-2244",
                        children: staticText.summaryTel
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ReturnSummary_ReturnSummary = (ReturnSummary);

// EXTERNAL MODULE: ./components/Returns/v1/ReturnList/returnList.module.scss
var returnList_module = __webpack_require__(94377);
var returnList_module_default = /*#__PURE__*/__webpack_require__.n(returnList_module);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./public/icons/install-service-cart-icon.svg
var install_service_cart_icon = __webpack_require__(99491);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Returns/v1/ReturnListItem/ReturnListItemTile.jsx








const ReturnListItemTile = (param)=>{
    let { isReturns , curstep , brandName ="" , currencySign , item ={} , staticText ={} , getItems =()=>{} , returnList =[] , handleReturnData =()=>{} , quantityVal ="" , returnVal ="" , totalQuantity ="" , isReturnConfirmed =false , returnedItems ={} , errorMsg ="" , setErrorMsg =()=>{}  } = param;
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [returnData, setReturnData] = (0,react.useState)(returnVal ? returnVal : "");
    const { itemName ="" , price ="" , sku ="" , description ="" , lwData ={} , orderQty ="" , udf2 ="" , udf1 ="" , discAmount ="" , udf6 =""  } = item;
    const getQuantity = (val)=>{
        let resultData = [];
        for(let i = 1; i <= val; i++){
            resultData.push(i);
        }
        return resultData;
    };
    const productData = (0,product/* getProductAttr */.Dv)(sku, lwData);
    const handleQuantity = (val)=>{
        const getPrice = val * price;
        setQuantity(val);
        getItems(price, val, getPrice);
    };
    var ref;
    const returnListData = (ref = returnList.map((list)=>{
        return list.value;
    })) !== null && ref !== void 0 ? ref : [];
    const handlePrice = (priceVal, discount)=>{
        const discountAmount = discount / totalQuantity;
        const price = priceVal - discountAmount;
        return price !== null && price !== void 0 ? price : 0;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "return-listitem__flexleft",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "return-listitemimg__img",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            className: "return-listitem__img ".concat(udf2 === "NA for service" ? "installation-img" : ""),
                            src: udf2 !== "NA for service" ? (productData === null || productData === void 0 ? void 0 : productData.image) ? productData.image : image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src : install_service_cart_icon/* default */.Z,
                            alt: itemName,
                            "area-label": itemName,
                            width: 90,
                            height: 120,
                            "aria-description": "image of product",
                            onError: (e)=>{
                                return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-det",
                        children: [
                            udf2 !== "NA for service" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-det__id",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: brandName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "product-det__sku",
                                                children: sku
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "product-det__name",
                                        children: itemName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "product-det__measure",
                                        children: [
                                            description,
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "product-det__color",
                                        children: "".concat(staticText.colorFinish, ": ").concat(udf2)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-det__installation",
                                children: staticText.installationService(udf6 !== "" ? udf6 : udf1)
                            }),
                            isReturns && curstep === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "product-det__cost",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: handlePrice(price, discAmount),
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currencySign,
                                    decimalScale: 2,
                                    fixedDecimalScale: true,
                                    thousandsGroupStyle: "lakh"
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "return-listitem__flexright ".concat(isReturns && curstep === 0 ? "return-listitem__flexedit" : ""),
                children: isReturns && curstep === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "return-listitem__quantity",
                            customClass: "quantity-field",
                            data: getQuantity(Number(quantityVal)),
                            value: quantity,
                            label: staticText.returnerQuantity,
                            onChange: (val)=>handleQuantity(val)
                        }),
                        udf2 !== "NA for service" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                    id: "return-listitem__reason",
                                    customClass: "returnreason-field",
                                    data: returnListData,
                                    value: returnData,
                                    label: staticText.reasonForReturn,
                                    onChange: (val)=>{
                                        handleReturnData(val), setErrorMsg(""), setReturnData(val);
                                    }
                                }),
                                errorMsg !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "reason-error",
                                    children: errorMsg
                                }) : null
                            ]
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return-listitem__checked--details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: staticText.returnerQuantity
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: isReturnConfirmed ? returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity : quantity
                                })
                            ]
                        }),
                        udf2 !== "NA for service" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return-listitem__checked--details",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: staticText.returnReason
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: returnData !== "" ? returnData : staticText.noReason
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ReturnListItem_ReturnListItemTile = (ReturnListItemTile);

// EXTERNAL MODULE: ./components/Returns/v1/ReturnListItem/returnListItem.module.scss
var returnListItem_module = __webpack_require__(42328);
var returnListItem_module_default = /*#__PURE__*/__webpack_require__.n(returnListItem_module);
;// CONCATENATED MODULE: ./components/Returns/v1/ReturnListItem/ReturnListItem.jsx







const ReturnListItem = (param)=>{
    let { isReturns =false , curstep =false , data ={} , brandName ="" , currencySign ="" , status ="" , skuId ="" , quantityVal ="" , getItems =()=>{} , reasonList =[] , handleReturnData =()=>{} , returnData ="" , totalQuantity ="" , isReturnConfirmed =false , returnedItems ={} , errorMsg ="" , setErrorMsg =()=>{}  } = param;
    var ref, ref1, ref2;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const shipItem = (data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.length) > 0 ? data === null || data === void 0 ? void 0 : (ref1 = data.item) === null || ref1 === void 0 ? void 0 : ref1.find((item)=>item.sku === skuId) : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (returnListItem_module_default()).returnListItem,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "return-listitem",
            children: [
                !isReturns ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "return-listitem__title",
                    children: staticText.returnedItems
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "return-listitem__card",
                    children: ((ref2 = Object.keys(shipItem)) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "return-listitem__flex return-listitem-carditems ".concat(status === "complete" ? "return-listitem__edit" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnListItem_ReturnListItemTile, {
                            isReturns: isReturns,
                            curstep: curstep,
                            item: shipItem,
                            brandName: brandName,
                            currencySign: currencySign,
                            staticText: staticText,
                            quantityVal: quantityVal,
                            returnList: reasonList,
                            getItems: getItems,
                            handleReturnData: handleReturnData,
                            returnVal: returnData,
                            totalQuantity: totalQuantity,
                            isReturnConfirmed: isReturnConfirmed,
                            returnedItems: returnedItems,
                            errorMsg: errorMsg,
                            setErrorMsg: setErrorMsg
                        })
                    }, shipItem === null || shipItem === void 0 ? void 0 : shipItem.sku) : null
                })
            ]
        })
    });
};
/* harmony default export */ var ReturnListItem_ReturnListItem = (ReturnListItem);

// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
;// CONCATENATED MODULE: ./components/Returns/v1/ReturnList/ReturnItemList.jsx







const ReturnItemList = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const [errorMsg, setErrorMsg] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const handleNext = ()=>{
        var ref;
        if (((ref = props.returnedItems) === null || ref === void 0 ? void 0 : ref.returnData) === "") {
            setErrorMsg(t("kf.returns.label.reasonReturnError"));
        } else {
            setErrorMsg("");
            props.handleUpdate(true);
            props.onNext();
        }
    };
    const getQuantity = ((ref3 = (ref1 = props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.shipDetail[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.item) === null || ref2 === void 0 ? void 0 : ref2.filter((list)=>list.sku === props.skuId)[0]) === null || ref3 === void 0 ? void 0 : ref3.shippedQty) - ((ref7 = (ref4 = props.orderData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.returns) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.order) === null || ref6 === void 0 ? void 0 : ref6.filter((item)=>{
        var ref;
        return item.order_no === ((ref = props.data) === null || ref === void 0 ? void 0 : ref.extOrderNo);
    })) === null || ref7 === void 0 ? void 0 : ref7.reduce((result, list)=>{
        var ref;
        return Number(result) + Number((ref = list.items[0]) === null || ref === void 0 ? void 0 : ref.return_qty);
    }, 0));
    var ref13, ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (returnList_module_default()).returnItem,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "returnItem__head",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "returnItem__section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnListItem_ReturnListItem, {
                        isReturns: true,
                        curstep: props.curStep,
                        data: (ref13 = (ref8 = props.data) === null || ref8 === void 0 ? void 0 : ref8.shipDetail[0]) !== null && ref13 !== void 0 ? ref13 : {},
                        brandName: props.brandName,
                        currencySign: props.currencySign,
                        status: props.status,
                        skuId: props.skuId,
                        quantityVal: getQuantity !== null && getQuantity !== void 0 ? getQuantity : "",
                        getItems: props.getItems,
                        reasonList: props.reasonList,
                        handleReturnData: props.handleReturnData,
                        orderData: props.orderData,
                        totalQuantity: (ref14 = (ref12 = (ref10 = props === null || props === void 0 ? void 0 : (ref9 = props.data) === null || ref9 === void 0 ? void 0 : ref9.shipDetail[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.item) === null || ref11 === void 0 ? void 0 : ref11.filter((list)=>list.sku === props.skuId)[0]) === null || ref12 === void 0 ? void 0 : ref12.shippedQty) !== null && ref14 !== void 0 ? ref14 : "",
                        errorMsg: errorMsg,
                        setErrorMsg: setErrorMsg
                    }),
                    props.status !== "complete" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "returnitem__nextbutton",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            customClass: "returnitem__next",
                            label: staticText.returnNext,
                            onClick: handleNext
                        })
                    }) : null
                ]
            })
        })
    });
};
/* harmony default export */ var ReturnList_ReturnItemList = (ReturnItemList);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/pdf-grey.svg
var pdf_grey = __webpack_require__(1405);
;// CONCATENATED MODULE: ./components/Returns/v1/FaultyProducts/UploadImage.jsx






const UploadImage = (props)=>{
    var ref;
    const { imageList: f , onDropOff  } = props;
    const onDelete = (file)=>{
        onDropOff(file);
    };
    const handleFocus = (e)=>{
        const { currentTarget: { classList ={}  } = {}  } = e;
        classList === null || classList === void 0 ? void 0 : classList.add("active-comment");
    };
    const handleBlur = (e)=>{
        const { currentTarget: { classList ={}  } = {}  } = e;
        classList === null || classList === void 0 ? void 0 : classList.remove("active-comment");
    };
    const fileSizeConverter = (data)=>{
        let size = parseInt(data);
        for (let unit of [
            "b",
            "Kb",
            "Mb",
            "Gb"
        ]){
            if (size < 1024) return "".concat(size.toFixed(2), " ").concat(unit);
            size /= 1024.0;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "upload-image-container ".concat(((ref = Object.entries(f)) === null || ref === void 0 ? void 0 : ref.length) ? "file-5" : ""),
        id: "contact-image-preview-container",
        tabIndex: "0",
        role: "presentation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            id: "input-id-active",
            className: "contact-us-image-preview",
            onClick: handleFocus,
            onBlur: handleBlur,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "preview-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: classnames_default()({
                            "image-box": (f === null || f === void 0 ? void 0 : f.type) !== "application/pdf"
                        }),
                        src: (f === null || f === void 0 ? void 0 : f.type) === "application/pdf" ? pdf_grey/* default */.Z === null || pdf_grey/* default */.Z === void 0 ? void 0 : pdf_grey/* default.src */.Z.src : f === null || f === void 0 ? void 0 : f.preview,
                        alt: f === null || f === void 0 ? void 0 : f.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "preview-desc-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "preview-image-name",
                            children: (0,helper.truncateString)(f === null || f === void 0 ? void 0 : f.name, 25)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "preview-image-size",
                            children: fileSizeConverter(f === null || f === void 0 ? void 0 : f.size)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "image-placeholder-".concat(f === null || f === void 0 ? void 0 : f.id)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "image-delete",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        tabIndex: "0",
                        className: "custom-close-icone",
                        onClick: ()=>onDelete(f),
                        src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                        alt: "close"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FaultyProducts_UploadImage = (UploadImage);

// EXTERNAL MODULE: ./components/Returns/v1/FaultyProducts/faultyProducts.module.scss
var faultyProducts_module = __webpack_require__(31979);
var faultyProducts_module_default = /*#__PURE__*/__webpack_require__.n(faultyProducts_module);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(68901);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
;// CONCATENATED MODULE: ./components/Returns/v1/FaultyProducts/FaultyProducts.jsx














const FaultyProducts = (param)=>{
    let { handleImages , onNext , status  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const [imageFiles, setImageFiles] = (0,react.useState)([]);
    const [isShow, setIsShow] = (0,react.useState)(true);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [errors, setErrors] = (0,react.useState)([]);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const handleNext = ()=>{
        const imagePayload = imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.map((file)=>{
            return {
                imageurl: file === null || file === void 0 ? void 0 : file.link,
                imagename: file === null || file === void 0 ? void 0 : file.name
            };
        });
        handleImages(imagePayload);
        onNext();
        setIsShow(false);
        setErrors([]);
    };
    const onDrag = (newFile)=>{
        setImageFiles([
            ...imageFiles,
            ...newFile
        ]);
    };
    const onDropOff = (file)=>{
        const newList = imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.filter((l)=>{
            return (l === null || l === void 0 ? void 0 : l.id) !== (file === null || file === void 0 ? void 0 : file.id);
        });
        setImageFiles([
            ...newList
        ]);
    };
    const handleCount = ()=>{
        setIsShow(true);
    };
    const onDrop = async (acceptedFiles, rejectedFiles)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        setIsLoading(true);
        const errList = (ref = rejectedFiles[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.map((el)=>{
            return el === null || el === void 0 ? void 0 : el.message;
        });
        errList && setErrors(errList);
        if (!errList && (errors === null || errors === void 0 ? void 0 : errors.length) > 0) setErrors([]);
        setErrors([]);
        try {
            const newImageList = await Promise.all(acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.map(async (f, i)=>{
                const res = await dispatch((0,genericSlice/* uploadImage */.Ix)({
                    uplaodData: f,
                    isReturn: true
                })).unwrap();
                return Object.assign(f, {
                    preview: URL.createObjectURL(f),
                    comment: "",
                    link: res === null || res === void 0 ? void 0 : res.path,
                    textCount: 0,
                    id: (0,lodash.uniqueId)()
                });
            }));
            onDrag(newImageList);
            setIsLoading(false);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
            setIsLoading(false);
        }
        if (((ref3 = (ref2 = rejectedFiles[0]) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "file-invalid-type") {
            setErrors([
                staticText === null || staticText === void 0 ? void 0 : staticText.errorFileType
            ]);
        } else if ((rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length) > 1) {
            setErrors([
                staticText === null || staticText === void 0 ? void 0 : staticText.uploadCountLimit
            ]);
        } else if (((ref4 = rejectedFiles[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.size) > 5e6) {
            setErrors([
                staticText === null || staticText === void 0 ? void 0 : staticText.uploadMBLimit
            ]);
        }
        if (!(rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length)) {
            setIsShow(false);
        }
        setIsLoading(false);
    };
    const validator = (file)=>{
        if ((file === null || file === void 0 ? void 0 : file.size) > 5e6) {
            return {
                message: staticText === null || staticText === void 0 ? void 0 : staticText.uploadMBLimit
            };
        }
        switch(file === null || file === void 0 ? void 0 : file.type){
            case "image/jpeg":
            case "image/png":
            case "image/gif":
            case "application/pdf":
                break;
            default:
                return {
                    message: staticText === null || staticText === void 0 ? void 0 : staticText.errorFileType
                };
        }
    };
    const { getRootProps , getInputProps  } = (0,dist_es/* useDropzone */.u)({
        accept: "image/png, image/jpg, image/jpeg, image/gif, application/pdf",
        maxFiles: 1,
        onDrop,
        validator
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (faultyProducts_module_default()).faultyDamaged,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: isLoading
            }),
            status === "edit" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "faulty-description",
                        children: staticText === null || staticText === void 0 ? void 0 : staticText.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "faulty-notes",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "The damage/faulty product should be clearly visible in image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Upload a clear product package image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Upload a product bar code image"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "faulty-image-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "faulty-image-list",
                            children: [
                                imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.map((data)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaultyProducts_UploadImage, {
                                        imageList: data,
                                        onDropOff: onDropOff,
                                        errors: errors,
                                        isLoading: isLoading
                                    });
                                }),
                                isShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "upload-image-container",
                                    id: "contact-image-preview-container",
                                    tabIndex: "0",
                                    role: "presentation",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "drag-and-drop-container",
                                            ...getRootProps(),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    ...getInputProps()
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "drag-and-drop-text-large",
                                                    children: staticText === null || staticText === void 0 ? void 0 : staticText.dragAndDrop
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "drag-and-drop-text-small",
                                                    children: staticText === null || staticText === void 0 ? void 0 : staticText.orText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "drag-and-drop-upload-btn",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        role: "button",
                                                        tabIndex: "-1",
                                                        className: "gbh-data-layer",
                                                        type: "ghost",
                                                        label: staticText === null || staticText === void 0 ? void 0 : staticText.uploadFileButton,
                                                        disabled: (imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.length) === 1 && lib/* isMobile */.tq || isLoading,
                                                        useDefaultClass: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            role: "region",
                                            "aria-live": "polite",
                                            className: "aria-messages",
                                            children: status
                                        }),
                                        errors && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "upload-image-container__error-msg",
                                            children: errors[0]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.length) < 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "faultyDamaged-add",
                        onClick: handleCount,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: staticText.faultLink
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "returnitem__nextbutton",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            customClass: "returnitem__next",
                            label: staticText.returnNext,
                            onClick: handleNext
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "returnitem_image_count",
                children: (imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.length) ? "".concat(imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.length, " Image Uploaded") : null
            })
        ]
    });
};
/* harmony default export */ var FaultyProducts_FaultyProducts = (FaultyProducts);

// EXTERNAL MODULE: ./components/Returns/v1/Review/review.module.scss
var review_module = __webpack_require__(67986);
var review_module_default = /*#__PURE__*/__webpack_require__.n(review_module);
;// CONCATENATED MODULE: ./components/Returns/v1/Review/Review.jsx






const Review = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (review_module_default()).returnReview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "returnReview__details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: staticText.reviewDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            staticText.reviewPara,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    staticText.reviewTerms,
                                    " "
                                ]
                            }),
                            staticText.reviewParagraph,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: staticText.reviewPrivacy
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "returnreview__submitbutton",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    role: "button",
                    customClass: "returnreview__submit",
                    disabled: false,
                    label: staticText.returnReviewSubmit,
                    onClick: ()=>props.onReview()
                })
            })
        ]
    });
};
/* harmony default export */ var Review_Review = (Review);

// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/Returns/v1/ContactInformation/contactInformation.module.scss
var contactInformation_module = __webpack_require__(62683);
var contactInformation_module_default = /*#__PURE__*/__webpack_require__.n(contactInformation_module);
;// CONCATENATED MODULE: ./components/Returns/v1/ContactInformation/ContactInformation.jsx










const ContactInformation = (props)=>{
    const { user: { sub: userEmail , firstName ="" , lastName ="" , login =""  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const handleNext = ()=>{
        props.onNext();
        props.handleOnNextStep();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (contactInformation_module_default()).contactInfo,
        children: props.status === "edit" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                        i18nKey: "kf.returns.label.contactRequired",
                        values: {
                            path: props.accountSettingsPath
                        },
                        components: {
                            anchor: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {})
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "contactInfo-fields",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row mx-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-sm-6 col-md-6 pl-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "kf-first-name",
                                        type: "text",
                                        value: firstName,
                                        maxLength: 60,
                                        label: "First Name",
                                        name: "fname",
                                        disabled: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-sm-6 col-md-6 pr-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        id: "kf-last-name",
                                        type: "text",
                                        value: lastName,
                                        maxLength: 60,
                                        label: "Last Name",
                                        name: "lname",
                                        disabled: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "kf-phone-number",
                            type: "text",
                            value: login,
                            maxLength: 60,
                            label: "Phone Number",
                            name: "phone",
                            disabled: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "kf-email",
                            type: "text",
                            value: userEmail,
                            maxLength: 60,
                            label: "Email",
                            name: "email",
                            disabled: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "returnitem__nextbutton",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        role: "button",
                        customClass: "returnitem__next",
                        disabled: false,
                        label: staticText.returnNext,
                        onClick: handleNext
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "contactInfo-values",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: firstName + " " + lastName
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: login
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: userEmail
                })
            ]
        })
    });
};
/* harmony default export */ var ContactInformation_ContactInformation = (ContactInformation);

// EXTERNAL MODULE: ./components/Returns/v1/returns.module.scss
var returns_module = __webpack_require__(21799);
var returns_module_default = /*#__PURE__*/__webpack_require__.n(returns_module);
// EXTERNAL MODULE: ./public/icons/back-arrow.svg
var back_arrow = __webpack_require__(64821);
// EXTERNAL MODULE: ./components/core/StepNavigator/StepNavigator.jsx + 1 modules
var StepNavigator = __webpack_require__(29754);
// EXTERNAL MODULE: ./public/icons/info.svg
var info = __webpack_require__(28139);
// EXTERNAL MODULE: ./components/Returns/v1/ReturnConfirmation/returnConfirmation.module.scss
var returnConfirmation_module = __webpack_require__(77978);
var returnConfirmation_module_default = /*#__PURE__*/__webpack_require__.n(returnConfirmation_module);
;// CONCATENATED MODULE: ./components/Returns/v1/ReturnConfirmation/ReturnConfirmation.jsx













const ReturnConfirmation = (param)=>{
    let { skuId ="" , faulyData =[] , returnedItems ={} , data ={} , currencySign ="" , brandName ="" , isReturns =false , curstep =1 , quantityVal =1 , reasonList =[] , getItems =()=>{} , handleReturnData =()=>{} , orderNumber ="" , orderDetailsUrl ="/" , isSuccess =false , orderSummary ={}  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { user: { sub: userEmail , firstName ="" , lastName ="" , login =""  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    var ref11;
    const shipItem = (ref11 = data === null || data === void 0 ? void 0 : (ref = data.item) === null || ref === void 0 ? void 0 : ref.find((item)=>item.sku === skuId)) !== null && ref11 !== void 0 ? ref11 : {};
    const isBundleAssociated = (shipItem === null || shipItem === void 0 ? void 0 : shipItem.udf6) !== "" ? ((ref5 = (ref3 = (ref2 = orderSummary === null || orderSummary === void 0 ? void 0 : (ref1 = orderSummary.shipments) === null || ref1 === void 0 ? void 0 : ref1.filter((list)=>{
        return (list === null || list === void 0 ? void 0 : list.extOrderNo) === "".concat(orderNumber, "-SRV");
    })[0]) === null || ref2 === void 0 ? void 0 : ref2.shipDetail[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : ref4.filter((service)=>{
        return service.udf6 === (shipItem === null || shipItem === void 0 ? void 0 : shipItem.udf6);
    })[0]) === null || ref5 === void 0 ? void 0 : ref5.canReturn) === "true" : false;
    const isServiceReturned = ((ref10 = (ref8 = (ref7 = orderSummary === null || orderSummary === void 0 ? void 0 : (ref6 = orderSummary.shipments) === null || ref6 === void 0 ? void 0 : ref6.filter((list)=>{
        return (list === null || list === void 0 ? void 0 : list.extOrderNo) === "".concat(orderNumber, "-SRV");
    })[0]) === null || ref7 === void 0 ? void 0 : ref7.shipDetail[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.item) === null || ref9 === void 0 ? void 0 : ref9.filter((list)=>list.sku === shipItem.udf1)[0]) === null || ref10 === void 0 ? void 0 : ref10.canReturn) === "true" ? true : false;
    const handleOrderRedirect = ()=>{
        const redirectionLink = "".concat(orderDetailsUrl, "?orderNumber=").concat(orderNumber, "&sku=").concat(shipItem === null || shipItem === void 0 ? void 0 : shipItem.udf1);
        window.location.href = redirectionLink;
    };
    const handleRefund = ()=>{
        var ref;
        let price = "";
        const getPrice = (shipItem === null || shipItem === void 0 ? void 0 : shipItem.price) * (returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity);
        const discount = (shipItem === null || shipItem === void 0 ? void 0 : shipItem.discAmount) / quantityVal * (returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity);
        price = getPrice - discount;
        return (ref = Number(price)) === null || ref === void 0 ? void 0 : ref.toFixed(2);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (returnConfirmation_module_default()).thankyouHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container kf-react-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "thankyou__back",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                                    alt: "Back"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    onClick: handleOrderRedirect,
                                    children: staticText.backToOrder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "thankyou-header__flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "thankyou-header__flex--detail",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: staticText.returnConfirmTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: staticText.returnConfirmPara
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: staticText.returnConfirmDay
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (returnConfirmation_module_default()).thankyouReturnitems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container kf-react-container thankyou-returnitems--summary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: staticText.returnConfirmItem
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "return-confirm-tile",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnListItem_ReturnListItem, {
                                isReturns: isSuccess,
                                curstep: curstep,
                                data: data !== null && data !== void 0 ? data : {},
                                brandName: brandName,
                                currencySign: currencySign,
                                staticText: staticText,
                                quantityVal: quantityVal,
                                returnList: reasonList,
                                getItems: getItems,
                                handleReturnData: handleReturnData,
                                skuId: skuId,
                                returnData: (returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.returnData) !== "" ? returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.returnData : staticText.noReason,
                                totalQuantity: quantityVal,
                                isReturnConfirmed: true,
                                returnedItems: returnedItems
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return-confirm-refund",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: staticText.refundAmount
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                        value: handleRefund(),
                                        displayType: "text",
                                        thousandSeparator: true,
                                        prefix: currencySign,
                                        decimalScale: 2,
                                        fixedDecimalScale: true,
                                        thousandsGroupStyle: "lakh",
                                        allowNegative: false
                                    })
                                })
                            ]
                        }),
                        (faulyData === null || faulyData === void 0 ? void 0 : faulyData.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return-confirm-faulty thankyou-contactinfo",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: staticText.faulty
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: (faulyData === null || faulyData === void 0 ? void 0 : faulyData.length) + " " + staticText.imageUpload
                                })
                            ]
                        }) : null,
                        firstName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "thankyou-contactinfo",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: staticText.requestContact
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: firstName + " " + lastName
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: login
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: userEmail
                                })
                            ]
                        }) : null,
                        isServiceReturned || isBundleAssociated && shipItem.udf2 !== "NA for service" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return-confirm-related",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    children: staticText.related
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "return-confirm-eligible",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: info/* default */.Z,
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "return-confirm-info",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: staticText.eligible
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: staticText.following
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "return-confirm-installation",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "return-confirm-sku",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: install_service_cart_icon/* default */.Z,
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: staticText.installationService((shipItem === null || shipItem === void 0 ? void 0 : shipItem.udf6) !== "" ? shipItem === null || shipItem === void 0 ? void 0 : shipItem.udf6 : shipItem === null || shipItem === void 0 ? void 0 : shipItem.udf1)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "return-confirm-price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                role: "button",
                                                tabIndex: "0",
                                                className: "return__service-button",
                                                onClick: handleOrderRedirect,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: info/* default */.Z,
                                                        alt: ""
                                                    }),
                                                    " ",
                                                    staticText.service
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ReturnConfirmation_ReturnConfirmation = (ReturnConfirmation);

// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
;// CONCATENATED MODULE: ./components/Returns/v1/analytics.js

const addReturnAnalytics = function(shipmentDetails, step) {
    let faultyData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    const { productDescription , productDimension , productId , productName , quantity , quantityTotalPrice , returnData , productCategory , basePrice , taxAmount , totalAmount , currency  } = shipmentDetails;
    const isFaultyAvailable = faultyData.length > 0;
    let eventAction, eventName, eventMsg, internalLinkName, internalLinkType, internalLinkURL;
    switch(step){
        case "one":
            eventAction = "returnItem:Init:Next";
            eventName = "returnItem:Init:Next";
            eventMsg = "return initiated - next step";
            internalLinkName = "return next";
            internalLinkType = "return:init:next";
            internalLinkURL = "/return/next";
            break;
        case "two":
            eventAction = "returnItem:UploadImage:Next";
            eventName = "returnItem:UploadImage:Next";
            eventMsg = "return image uploaded - next step";
            internalLinkName = "return upload image next";
            internalLinkType = "return:uploadImage:next";
            internalLinkURL = "/return/upload-image-next";
            break;
        case "three":
            eventAction = "returnItem:UpdateContact:Next";
            eventName = "returnItem:UpdateContact:Next";
            eventMsg = "user proceeded to update contact information";
            internalLinkName = "return update contact next";
            internalLinkType = "return:updateContact:next";
            internalLinkURL = "/return/contact-info";
            break;
        default:
            eventAction = "returnItem:FinalSubmit";
            eventName = "returnItem:FinalSubmit";
            eventMsg = "user submitted final return request";
            internalLinkName = "return final submit";
            internalLinkType = "return:finalSubmit";
            internalLinkURL = "/return/final-submit";
            break;
    }
    const eventInfo = {
        eventAction: eventAction,
        eventName: eventAction,
        eventType: "form interaction",
        eventMsg: eventMsg,
        eventStatus: "success",
        internalLinkName: internalLinkName,
        internalLinkPosition: "return page",
        internalLinkType: internalLinkType,
        internalLinkZoneName: "return:form",
        internalLinkURL: internalLinkURL,
        clickInternalLinks: "true"
    };
    const returnInfo = {
        productID: productId,
        productName: productName,
        productCategory: productCategory,
        productColor: productDescription,
        productDimensions: productDimension,
        returnReason: returnData,
        returnQuantity: quantity,
        productPrice: quantityTotalPrice,
        currency: "INR",
        ...isFaultyAvailable && {
            imageAttached: true
        },
        ...isFaultyAvailable && {
            imageCount: faultyData.length
        }
    };
    const orderInfo = {
        basePrice: basePrice,
        taxAmount: taxAmount,
        shipping: 0.0,
        totalAmount: totalAmount,
        currency: currency,
        shippingMethod: "ground"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        returnInfo,
        ...step === "four" && {
            orderInfo
        },
        page
    });
};

;// CONCATENATED MODULE: ./components/Returns/v1/Returns.jsx


























const Returns = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    const [data, setData] = (0,react.useState)({});
    const [orderSummary, setOrderSummary] = (0,react.useState)({});
    const [isSuccess, setIsSuccess] = (0,react.useState)(false);
    const [config, setConfig] = (0,react.useState)({});
    const [returnedItems, setReturnedItems] = (0,react.useState)({
        price: 0,
        quantity: 1,
        returnData: "",
        quantityTotalPrice: "",
        isUpdated: false,
        productName: "",
        productId: "",
        productDescription: "",
        productDimension: "",
        productCategory: ""
    });
    const [faulyData, setFaultyData] = (0,react.useState)([]);
    const [dataLoading, setDataLoading] = (0,react.useState)(true);
    const [isShowModal, setIsShowModal] = (0,react.useState)(false);
    const { user: { sub: userEmail  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { reasonList =[]  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const router = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const { orderNumber , shipmentId , sku  } = router.query;
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((list)=>{
            setConfig(list);
        });
        getOrder();
    }, []);
    const handleDiscount = (discount, quantityVal, selectedQuantity)=>{
        const getDiscount = discount / quantityVal * selectedQuantity;
        return getDiscount;
    };
    const handleTax = (tax, priceVal)=>{
        var ref;
        const getTaxPercentage = parseFloat(tax) + 100;
        const getTax = (ref = Number(tax / getTaxPercentage * priceVal)) === null || ref === void 0 ? void 0 : ref.toFixed(2);
        return getTax !== null && getTax !== void 0 ? getTax : 0;
    };
    const handleMRP = (price, quantity)=>{
        const getMRP = price * quantity;
        return getMRP;
    };
    const getOrder = async ()=>{
        await store/* store.dispatch */.h.dispatch((0,genericSlice/* getGenericListPath */.Ln)());
        await store/* store.dispatch */.h.dispatch((0,genericSlice/* getReasonList */.ph)());
        const payload = {
            email: userEmail,
            orderId: orderNumber
        };
        try {
            const res = await api/* apim.post */.TH.post("checkout/orders/v1/query", payload);
            if (res) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
                var ref33;
                let shipments = (ref33 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.order_detail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.shipments) === null || ref2 === void 0 ? void 0 : ref2.filter((item)=>{
                    var ref;
                    return ((ref = item.shipDetail[0]) === null || ref === void 0 ? void 0 : ref.trackingNumber) === shipmentId;
                })[0]) !== null && ref33 !== void 0 ? ref33 : {};
                let lineItems = (ref3 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.item) === null || ref4 === void 0 ? void 0 : ref4.filter((item)=>item.sku === sku);
                const lwCartItems = await (0,product/* getLineItemAttrs */.lP)(lineItems !== null && lineItems !== void 0 ? lineItems : []);
                lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach((order)=>{
                    const { lwData  } = lwCartItems.find((prod)=>prod.sku === order.sku);
                    order.lwData = lwData;
                });
                var ref34;
                const priceVal = (ref34 = (ref7 = (ref5 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.item) === null || ref6 === void 0 ? void 0 : ref6.filter((item)=>item.sku === sku)[0]) === null || ref7 === void 0 ? void 0 : ref7.price) !== null && ref34 !== void 0 ? ref34 : 0;
                var ref35;
                const productName = (ref35 = (ref10 = (ref8 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.item) === null || ref9 === void 0 ? void 0 : ref9.filter((item)=>item.sku === sku)[0]) === null || ref10 === void 0 ? void 0 : ref10.itemName) !== null && ref35 !== void 0 ? ref35 : "";
                var ref36;
                const productId = (ref36 = (ref13 = (ref11 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.item) === null || ref12 === void 0 ? void 0 : ref12.filter((item)=>item.sku === sku)[0]) === null || ref13 === void 0 ? void 0 : ref13.sku) !== null && ref36 !== void 0 ? ref36 : "";
                var ref37;
                const productDescription = (ref37 = (ref16 = (ref14 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.item) === null || ref15 === void 0 ? void 0 : ref15.filter((item)=>item.sku === sku)[0]) === null || ref16 === void 0 ? void 0 : ref16.udf2) !== null && ref37 !== void 0 ? ref37 : "";
                var ref38;
                const productDimension = (ref38 = (ref19 = (ref17 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.item) === null || ref18 === void 0 ? void 0 : ref18.filter((item)=>item.sku === sku)[0]) === null || ref19 === void 0 ? void 0 : ref19.description) !== null && ref38 !== void 0 ? ref38 : "";
                const productCategory = (ref20 = lwCartItems.find((prod)=>prod.sku === sku)) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.lwData) === null || ref21 === void 0 ? void 0 : ref21.Product_Category;
                const quantityVal = ((ref22 = Object.keys(shipments)) === null || ref22 === void 0 ? void 0 : ref22.length) > 0 ? (ref25 = (ref23 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.item) === null || ref24 === void 0 ? void 0 : ref24.filter((list)=>list.sku === sku)[0]) === null || ref25 === void 0 ? void 0 : ref25.shippedQty : 0;
                var ref39;
                const currencySign = (ref39 = config === null || config === void 0 ? void 0 : (ref26 = config.internationalization) === null || ref26 === void 0 ? void 0 : ref26.currencySign) !== null && ref39 !== void 0 ? ref39 : "";
                const individualData = ((ref27 = Object.keys(shipments)) === null || ref27 === void 0 ? void 0 : ref27.length) > 0 ? (ref28 = shipments === null || shipments === void 0 ? void 0 : shipments.shipDetail[0]) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.item) === null || ref29 === void 0 ? void 0 : ref29.filter((list)=>list.sku === sku)[0] : {};
                const { price ="" , discAmount ="" , taxPercentage =""  } = individualData;
                const discountAmount = handleDiscount(discAmount, quantityVal, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity);
                const refundTotal = handleMRP(price, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity) - handleDiscount(discAmount, quantityVal, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity);
                const tax = handleTax(taxPercentage, handleMRP(price, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity) - handleDiscount(discAmount, quantityVal, returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity));
                const basePrice = refundTotal - +tax;
                setReturnedItems({
                    ...returnedItems,
                    price: (ref30 = Number(priceVal)) === null || ref30 === void 0 ? void 0 : ref30.toFixed(2),
                    quantityTotalPrice: (ref31 = Number(priceVal)) === null || ref31 === void 0 ? void 0 : ref31.toFixed(2),
                    productName,
                    productId,
                    productDescription,
                    productDimension,
                    productCategory,
                    basePrice,
                    taxAmount: tax,
                    totalAmount: refundTotal,
                    currency: currencySign
                });
                setData(shipments !== null && shipments !== void 0 ? shipments : {});
                var ref40;
                setOrderSummary((ref40 = res === null || res === void 0 ? void 0 : (ref32 = res.data) === null || ref32 === void 0 ? void 0 : ref32.order_detail) !== null && ref40 !== void 0 ? ref40 : {});
                setDataLoading(false);
            }
        } catch (err) {
            console.log(err);
            setDataLoading(false);
        }
    };
    const handleSubmit = async ()=>{
        try {
            var ref, ref1;
            var ref2, ref3;
            const payload = {
                returnRequestData: {
                    orderNumber: (ref2 = data === null || data === void 0 ? void 0 : data.extOrderNo) !== null && ref2 !== void 0 ? ref2 : "",
                    items: {
                        quantity: returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.quantity,
                        comment: (returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.returnData) !== "" ? returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.returnData : staticText.noReason,
                        sku: sku,
                        price: (ref3 = returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.price) !== null && ref3 !== void 0 ? ref3 : "",
                        trackingno: shipmentId,
                        invoiceno: ((ref = Object.keys(data)) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = data === null || data === void 0 ? void 0 : data.shipDetail[0]) === null || ref1 === void 0 ? void 0 : ref1.invoiceNo : "",
                        images: faulyData
                    }
                }
            };
            const res = await api/* apim.post */.TH.post("/return/create?type=single", payload);
            if (res) {
                setIsSuccess(true);
            }
        } catch (err) {
            console.log(err);
        }
    };
    var ref28, ref29, ref30;
    const steps = [
        {
            label: staticText.returnItem,
            content: ReturnList_ReturnItemList,
            props: {
                data: ((ref = Object.keys(data)) === null || ref === void 0 ? void 0 : ref.length) > 0 ? data : {},
                orderData: orderSummary !== null && orderSummary !== void 0 ? orderSummary : {},
                currencySign: (ref28 = config === null || config === void 0 ? void 0 : (ref1 = config.internationalization) === null || ref1 === void 0 ? void 0 : ref1.currencySign) !== null && ref28 !== void 0 ? ref28 : "",
                brandName: ((ref2 = Object.keys(data)) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? data === null || data === void 0 ? void 0 : data.owner : "",
                skuId: sku,
                returnedItems: returnedItems,
                reasonList: reasonList,
                getItems: (price, quantity, quantityTotalPrice)=>setReturnedItems({
                        ...returnedItems,
                        price: price,
                        quantity: quantity,
                        quantityTotalPrice: quantityTotalPrice
                    }),
                handleReturnData: (val)=>setReturnedItems({
                        ...returnedItems,
                        returnData: val
                    }),
                handleUpdate: (val)=>{
                    setReturnedItems({
                        ...returnedItems,
                        isUpdated: val
                    });
                    addReturnAnalytics(returnedItems, "one");
                }
            }
        },
        {
            label: staticText.faulty,
            content: FaultyProducts_FaultyProducts,
            props: {
                handleImages: (addRows)=>{
                    setFaultyData(addRows);
                    addReturnAnalytics(returnedItems, "two", addRows);
                }
            }
        },
        {
            label: staticText.contactInfo,
            content: ContactInformation_ContactInformation,
            props: {
                data: (ref29 = orderSummary === null || orderSummary === void 0 ? void 0 : orderSummary.shipping_address) !== null && ref29 !== void 0 ? ref29 : {},
                accountSettingsPath: (ref30 = config === null || config === void 0 ? void 0 : (ref3 = config.general) === null || ref3 === void 0 ? void 0 : ref3.accountSettingsPath) !== null && ref30 !== void 0 ? ref30 : "/",
                handleOnNextStep: ()=>{
                    addReturnAnalytics(returnedItems, "three");
                }
            }
        },
        {
            label: staticText.review,
            content: Review_Review,
            props: {
                onReview: ()=>{
                    handleSubmit();
                    addReturnAnalytics(returnedItems, "four");
                }
            }
        }
    ];
    const handleRedirection = ()=>{
        if (returnedItems === null || returnedItems === void 0 ? void 0 : returnedItems.isUpdated) {
            setIsShowModal(true);
        } else {
            redirectionToOrder();
        }
    };
    const redirectionToOrder = ()=>{
        var ref;
        setIsShowModal(false);
        const redirectionLink = "".concat(config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.orderDetailsPath, "?orderNumber=").concat(orderNumber);
        window.location.href = redirectionLink;
    };
    var ref31, ref32, ref33, ref34;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (returns_module_default()).returnRequest,
        children: dataLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "page-load-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: dataLoading
            })
        }) : !isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container kf-react-container return-request",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "returnItem__back",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                            alt: "Back"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            onClick: handleRedirection,
                            children: staticText.backToOrder
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "return-request__header-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return-request__items-wrapper",
                            children: [
                                ((ref4 = Object.keys(data)) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "returnItem__title",
                                    children: staticText.returnRequestOrder(orderNumber, orderSummary === null || orderSummary === void 0 ? void 0 : (ref5 = orderSummary.shipments) === null || ref5 === void 0 ? void 0 : ref5.map((item, index)=>({
                                            ...item,
                                            index
                                        })).filter((list)=>{
                                        var ref;
                                        return ((ref = list.shipDetail[0]) === null || ref === void 0 ? void 0 : ref.trackingNumber) === shipmentId;
                                    }).map((item)=>item.index + 1), orderSummary === null || orderSummary === void 0 ? void 0 : (ref6 = orderSummary.shipments) === null || ref6 === void 0 ? void 0 : ref6.length)
                                }) : null,
                                ((ref7 = Object.keys(data)) === null || ref7 === void 0 ? void 0 : ref7.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepNavigator/* default */.Z, {
                                    data: ((ref10 = (ref8 = data === null || data === void 0 ? void 0 : data.shipDetail[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.item) === null || ref9 === void 0 ? void 0 : ref9.filter((item)=>item.sku === sku)[0]) === null || ref10 === void 0 ? void 0 : ref10.udf2) === "NA for service" ? steps === null || steps === void 0 ? void 0 : steps.filter((item)=>item.label !== staticText.faulty) : steps
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "return-request__summary-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnSummary_ReturnSummary, {
                                data: ((ref11 = Object.keys(data)) === null || ref11 === void 0 ? void 0 : ref11.length) > 0 ? (ref12 = data === null || data === void 0 ? void 0 : data.shipDetail[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.item) === null || ref13 === void 0 ? void 0 : ref13.filter((list)=>list.sku === sku)[0] : {},
                                quantityVal: ((ref14 = Object.keys(data)) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 ? (ref17 = (ref15 = data === null || data === void 0 ? void 0 : data.shipDetail[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.item) === null || ref16 === void 0 ? void 0 : ref16.filter((list)=>list.sku === sku)[0]) === null || ref17 === void 0 ? void 0 : ref17.shippedQty : 0,
                                currencySign: (ref31 = config === null || config === void 0 ? void 0 : (ref18 = config.internationalization) === null || ref18 === void 0 ? void 0 : ref18.currencySign) !== null && ref31 !== void 0 ? ref31 : "",
                                returnedItems: returnedItems,
                                tax: (ref32 = orderSummary === null || orderSummary === void 0 ? void 0 : (ref19 = orderSummary.order_summary) === null || ref19 === void 0 ? void 0 : ref19.tax) !== null && ref32 !== void 0 ? ref32 : 0
                            })
                        })
                    ]
                }),
                isShowModal ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                    showModal: isShowModal,
                    onModalClose: ()=>setIsShowModal(false),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: staticText.areYou
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: staticText.allProgress
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "return__modal-cta",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "black",
                                    role: "button",
                                    label: staticText.yes,
                                    onClick: redirectionToOrder,
                                    size: "small",
                                    className: "return__modal-button"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "ghost",
                                    role: "button",
                                    label: staticText.no,
                                    size: "small",
                                    onClick: ()=>setIsShowModal(false),
                                    className: "return__modal-button"
                                })
                            ]
                        })
                    ]
                }) : null
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnConfirmation_ReturnConfirmation, {
            faulyData: faulyData,
            data: ((ref20 = Object.keys(data)) === null || ref20 === void 0 ? void 0 : ref20.length) > 0 ? data === null || data === void 0 ? void 0 : data.shipDetail[0] : {},
            returnedItems: returnedItems,
            skuId: sku,
            currencySign: (ref33 = config === null || config === void 0 ? void 0 : (ref21 = config.internationalization) === null || ref21 === void 0 ? void 0 : ref21.currencySign) !== null && ref33 !== void 0 ? ref33 : "",
            brandName: ((ref22 = Object.keys(data)) === null || ref22 === void 0 ? void 0 : ref22.length) > 0 ? data === null || data === void 0 ? void 0 : data.owner : "",
            isReturns: isSuccess,
            curstep: 1,
            orderNumber: orderNumber,
            orderDetailsUrl: (ref34 = config === null || config === void 0 ? void 0 : (ref23 = config.general) === null || ref23 === void 0 ? void 0 : ref23.orderDetailsPath) !== null && ref34 !== void 0 ? ref34 : "/",
            quantityVal: ((ref24 = Object.keys(data)) === null || ref24 === void 0 ? void 0 : ref24.length) > 0 ? (ref27 = (ref25 = data === null || data === void 0 ? void 0 : data.shipDetail[0]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.item) === null || ref26 === void 0 ? void 0 : ref26.filter((list)=>list.sku === sku)[0]) === null || ref27 === void 0 ? void 0 : ref27.shippedQty : 0,
            orderSummary: orderSummary
        })
    });
};


;// CONCATENATED MODULE: ./page/returns.jsx












const returns_Returns = (param)=>{
    let { tmpData: data , headertmp: header , footertmp: footer , globalScript , footerScript , analysticsScript , analyticsData  } = param;
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper.getDataLayerObj)(analyticsData);
    }, [
        analyticsData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data === null || data === void 0 ? void 0 : data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                breadCrumb: (data, fullData)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
                        data: data,
                        fullData: fullData
                    }),
                landing: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Returns, {
                        data: data
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */ async function getServerSideProps(param) {
    let { req , locale  } = param;
    // await i18n?.reloadResources()
    const isPreviewMode = req.cookies["aem-author-preview-mode"];
    const { data  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: constants.previewContentPrefix + constants.returnsUrl,
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: (0,helper.buildUrlForAemApim)(constants.returnsUrl),
        method: "GET"
    });
    const { data: header  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(data.headerExpFrg ? data.headerExpFrg : constants.headerUrl, ".model.json"),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.headerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.headerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.headerUrl, ".model.json")),
        method: "get"
    });
    const { data: footer  } = isPreviewMode ? await (0,api/* aemPreviewAxiosInstance */.IT)({
        url: "".concat(data.footerExpFrg ? data.footerExpFrg : constants.footerUrl, ".model.json"),
        method: "GET"
    }) : await (0,api/* aemApimAxiosInstance */.v0)({
        url: data.footerExpFrg ? (0,helper.buildUrlForAemApim)("".concat(data.footerExpFrg, ".model.json")) : (0,helper.buildUrlForAemApim)("".concat(constants.footerUrl, ".model.json")),
        method: "GET"
    });
    const globalScript = data === null || data === void 0 ? void 0 : data.globalScript;
    const footerScript = (data === null || data === void 0 ? void 0 : data.footerScript) ? data.footerScript : null;
    const topHeadScript = (data === null || data === void 0 ? void 0 : data.topHeadScript) ? data === null || data === void 0 ? void 0 : data.topHeadScript : null;
    const analysticsScript = (data === null || data === void 0 ? void 0 : data.adobeAnalytic) || null;
    let tmpData = {};
    if (data.pageComponentProperties) {
        tmpData = data.pageComponentProperties;
    } else {
        tmpData = data;
    }
    tmpData = (0,helper.filterBackEndJson)(tmpData);
    const analyticsData = data === null || data === void 0 ? void 0 : data.data;
    const headertmp = (0,helper.filterBackEndJson)(header);
    const footertmp = (0,helper.filterBackEndJson)(footer);
    return {
        props: {
            tmpData,
            headertmp,
            footertmp,
            globalScript,
            analyticsData,
            footerScript,
            topHeadScript,
            analysticsScript,
            ...await (0,serverSideTranslations.serverSideTranslations)(locale, [
                "common"
            ])
        }
    };
}
/* harmony default export */ var returns = (returns_Returns);


/***/ }),

/***/ 58589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getToken; },
/* harmony export */   "S": function() { return /* binding */ downloadFile; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55111);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);



const downloadFile = (path, accessToken)=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.downloadFileURL, "?fileName=").concat(path), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                },
                responseType: "blob"
            });
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};
const getToken = async ()=>{
    return new Promise(async (resolve, reject)=>{
        try {
            const response = await axios__WEBPACK_IMPORTED_MODULE_0___default().post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__.apiBaseUrl).concat(_constants__WEBPACK_IMPORTED_MODULE_1__.oktaTokenEndpoint, "?scope=guest&channel=india"));
            resolve(response);
        } catch (error) {
            reject(error);
        }
    });
};


/***/ }),

/***/ 62683:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactInfo":"contactInformation_contactInfo__m_xk2"};

/***/ }),

/***/ 31979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faultyDamaged":"faultyProducts_faultyDamaged__LQRN1"};

/***/ }),

/***/ 77978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"thankyouHeader":"returnConfirmation_thankyouHeader__oaBhP","thankyouReturnitems":"returnConfirmation_thankyouReturnitems__gVJVx"};

/***/ }),

/***/ 94377:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"returnItem":"returnList_returnItem__tkxbz"};

/***/ }),

/***/ 42328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"returnListItem":"returnListItem_returnListItem__mpmDU"};

/***/ }),

/***/ 64851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"returnSummary":"returnSummary_returnSummary__KaXed"};

/***/ }),

/***/ 67986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"returnReview":"review_returnReview__Rcm41"};

/***/ }),

/***/ 21799:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"returnRequest":"returns_returnRequest__136UY"};

/***/ }),

/***/ 78112:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stepNavWrapper":"StepNav_stepNavWrapper__PZZMo"};

/***/ }),

/***/ 40816:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6351,3662,1966,7333,8153,33,5709,6609,1433,6051,9774,2888,179], function() { return __webpack_exec__(9359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);